
import api from 'services/api';
import { SITE_MODE, SITE_MODES } from 'config/site-mode';

export const postShoppingCart = async (projectId, token) => {
  const endpoint = `/api/projects/${projectId}/shopping-cart/${SITE_MODE.toLowerCase()}`;

  if (SITE_MODE === SITE_MODES.RENSA) {
    return api.post(endpoint, { token });
  }

  if (SITE_MODE === SITE_MODES.TU) {
    return api.getXML(endpoint);
  }

  return false;
};




// WEBPACK FOOTER //
// ./js/services/shopping-cart.js